<template>
<div class="home">
    <div class="home-container nj-cols c3" v-if="usuario">
        <div class="group" v-for="grupo in modulo_grupos" :key="grupo.mgp_id">
            <div class="group-title">{{ grupo.mgp_nombre }}</div>
            <div class="group-content nj-cols form c2">
                <router-link class="option" v-for="modulo in grupo.modulos" :key="modulo.mod_id" :to="modulo.mod_url">{{ modulo.mod_nombre }}</router-link>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import StoreAdapter from "../store/StoreAdapter"
import { Toast, Validator } from "../util"
export default {
    name: "Home",
    data() {
        return {

        }
    },
    computed: {
        usuario() {
            return StoreAdapter.get(StoreAdapter.modules.UsuarioStore.getters.usuario)
        },
        modulo_grupos() {
            return StoreAdapter.get(StoreAdapter.modules.UsuarioStore.getters.usuario).modulo_grupos
        }
    },
    methods: {

    },
    mounted() {
        if(Validator.isNotNull(this.$route.params.message)) {
            Toast.error(this.$route.params.message)
        }
    }
}
</script>
<style scoped>
.home {
    width: 100%;
    display: flex;
    justify-content: center;
}

.home-container {
    width: 100%;
    max-width: 1000px;
}

.group {
    background-color: #fff;
    border: 1px solid #ccc;
    padding: 8px;
    border-radius: 4px;
}

.group-title {
    font-size: 10px !important;
    margin: 0 4px 8px 4px;
    font-weight: bold;
}

.option {
    background-color: #f4f4f4;
    padding: 12px;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    border: 1px solid #ccc;
}

.option:hover {
    color: #fff !important;
    border-color: var(--nj-color-blue);
    background-color: var(--nj-color-blue);
}
</style>